// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = '2dedf403e3a1ec564fd9f2794dd12ccf9a7c56c0';
/* tslint:enable */
